import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { PictureInitialParentType } from '~/apollo/generated/v4/graphql';
import { Modal } from '~/components/common/Modal';
import { Button } from '~/components/ui/button';
import type { PictureUploadAutofillValues } from '~/components/upload/file/picture-upload-v4';
import { PictureUploadV4 } from '~/components/upload/file/picture-upload-v4';
import { useModalState } from '~/hooks/modal';
import type { RefetchQueries } from '~/utils/graphql';

export function UploadPicturesModal({
  parentType,
  parentId,
  disabled,
  refetchQueries,
  autofillValues,
}: {
  parentType: PictureInitialParentType;
  parentId: number;
  disabled?: boolean;
  refetchQueries: RefetchQueries;
  autofillValues?: PictureUploadAutofillValues;
}) {
  const { show, showModal, hideModal } = useModalState();

  return (
    <>
      <Button
        type="button"
        color="primary"
        size="xs"
        onClick={showModal}
        disabled={disabled}
        className="inline-block"
        startIcon={<FontAwesomeIcon icon={faUpload} />}
      >
        Upload Pictures
      </Button>

      <Modal open={show} onHide={hideModal} size="lg">
        <Modal.Body heading="Upload Pictures">
          <PictureUploadV4
            parentType={parentType}
            parentId={parentId}
            refetchQueries={refetchQueries}
            autofillValues={autofillValues}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
